import { create } from "zustand"

/**
 * Scripts-Only browse mode — see docs/SCRIPTS_ONLY_GRID_TASK_PLAN.md.
 *
 * Deliberately NOT persisted: it swaps the grid's entire data source away
 * from the user's selected sources, so restoring it on a cold load would
 * look like the normal feed had broken.
 */
interface ScriptsOnlyState {
  scriptsOnly: boolean
  setScriptsOnly: (value: boolean) => void
  toggleScriptsOnly: () => void
}

export const useScriptsOnlyStore = create<ScriptsOnlyState>((set) => ({
  scriptsOnly: false,
  setScriptsOnly: (value) => set({ scriptsOnly: value }),
  toggleScriptsOnly: () => set((state) => ({ scriptsOnly: !state.scriptsOnly })),
}))
